import { useToast } from '@/composables/useToast';

interface ICopyToClipboardComposable {
  copyToClipboard: (text: string, successMessage?: string) => Promise<void>;
}

/**
 * Copies text to the clipboard and (optionally) shows a success toast.
 * Errors are surfaced through the shared toast error handling.
 */
export const useCopyToClipboard = (): ICopyToClipboardComposable => {
  const { catchError, customSuccessToast } = useToast();

  const copyToClipboard = async (text: string, successMessage?: string): Promise<void> => {
    await catchError(async () => {
      await navigator.clipboard.writeText(text);
      if (successMessage) {
        customSuccessToast(successMessage);
      }
    });
  };

  return { copyToClipboard };
};
